import { attr, belongsTo } from "@ember-data/model";
import dayjs from "dayjs";
import {
  validateDate,
  validatePresence
} from "ember-changeset-validations/validators";
import type IntlService from "ember-intl/services/intl";
import JournalEvent from "parog-web/models/journal-event";
import tWithDefault from "parog-web/utils/t-with-default";
import type CnamProcessStartedJournalEvent from "./cnam-process-started-journal-event";
import type Patient from "./patient";

//---- Automatically generated, don't update this part ----

/**
 * The goal of this JE is to represent a DMP document
 * that has been retrieved from the patient's DMP
 */
export default class DocumentRetrievedJournalEvent extends JournalEvent {
  static override type = "document-retrieved-journal-event";

  @attr("string") declare title: string;

  @attr("string") declare classCode: string;

  @attr("string") declare classCodeLabel: string;

  @attr("string") declare docType: string;

  @attr("string") declare docTypeLabel: string;

  @attr("string") declare mimeType: string;

  @attr("string") declare uniqueId: string;

  @attr("string") declare cdaHeaders: string;

  @attr("string") declare source: string;

  @belongsTo("cnam-process-started-journal-event", {
    async: false,
    inverse: "documentRetrievedJournalEvents"
  })
  declare cnamProcessStartedJournalEvent: CnamProcessStartedJournalEvent;

  static override validations(intl: IntlService) {
    return {
      occurredAt: [
        validatePresence({
          presence: true,
          description: tWithDefault(
            intl,
            "validations.document-retrieved-journal-event.occurred-at",
            "La date"
          )
        }),
        validateDate({
          message:
            "Cette donnée ne peut être déclarée avant 1900. Veuillez modifier la date",
          onOrAfter: new Date("01/01/1900")
        }),
        validateDate({
          message:
            "Cette donnée ne peut être déclarée dans le futur. Veuillez modifier la date",
          onOrBefore: dayjs().endOf("day").toDate()
        })
      ]
    };
  }

  //---- End of generated code ----

  override get description() {
    return `${this.title} du ${dayjs(this.occurredAt).format("DD/MM/YYYY")}`;
  }

  get displayRoute() {
    return "default-display";
  }

  @belongsTo("patient", {
    async: false,
    inverse: "documentRetrievedJournalEvents"
  })
  declare patient: Patient;
}

// DO NOT DELETE: this is how TypeScript knows how to look up your models.
declare module "ember-data/types/registries/model" {
  export default interface ModelRegistry {
    "document-retrieved-journal-event": DocumentRetrievedJournalEvent;
  }
}
